import { useEffect, useState } from "react";
import "./TabsComponentNotesLevel.css";

const TabsComponentNotesLevel = ({
  handlePage,
  tabsData,
  labelClass = "",
  forPage = "",
  doesHaveAll = false,
  controlledActiveTab = false,
  disabled = false,
  suppressActive = false,
  cn = "",
}) => {
  const [activeTab, setActiveTab] = useState("treatment");
  useEffect(() => {
    if (handlePage === "detail" && forPage !== "Defendants" && forPage !== "Insurance") {
      setActiveTab("treatment");
    } else {
      setActiveTab(handlePage);
    }
  }, [handlePage]);

  const handleTabClick = (tabId) => {
    if (disabled) return;

    if (tabId !== "newProvider" && tabId !== "treatmentDates") {
      if (!controlledActiveTab) setActiveTab(tabId);
      const tab = tabsData.find((tab) => tab.id === tabId);
      tab.onClick();
    } else {
      const tab = tabsData.find((tab) => tab.id === tabId);
      tab.onClick();
    }
  };
  const selectedTab = suppressActive ? null : controlledActiveTab ? handlePage : activeTab;
  return (
    <nav className="notes-nav-tabs p-0">
      <div
        className={`nav nav-tabs d-flex-md-1 notes-tabs-container ${labelClass}`}
        id="nav-tab-account-checks"
        role="tablist"
        style={{}}
      >
        {/* ALL TAB */}
        <div
          className="d-flex align-items-center ignoring-this-div"
          style={{
            paddingRight: "5px",
            width: "max-content",
          }}
        >
          {tabsData?.map((tab, index) => {
            const isAll = tab.id === "all" ? true : false;
            const isSettlementAll = tab?.id === "settlement" ? true : false;
            if (isSettlementAll && doesHaveAll)
              return (
                <a
                  className={`nav-item nav-link custom-hover-tabs-z-index show rlmargin-z note-categories-spaces notes-all-left-tab ${!disabled && selectedTab === tab?.id ? "active" : ""}
                            `}
                  onClick={disabled ? undefined : () => handleTabClick(tab.id)}
                  aria-disabled={disabled || undefined}
                  tabIndex={disabled ? -1 : undefined}
                  style={{
                    // minWidth: "39px",
                    width: "max-content",
                  }}
                >
                  <span
                    style={{
                      position: "relative",
                      // right: "2.5px",
                    }}
                  >
                    {tab?.label}
                  </span>
                </a>
              );
            if (isAll && doesHaveAll)
              return (
                <a
                  className={`nav-item nav-link custom-hover-tabs-z-index show rlmargin-z note-categories-spaces notes-all-left-tab ${!disabled && selectedTab === "all" ? "active" : ""}
                            `}
                  onClick={disabled ? undefined : () => handleTabClick(tab.id)}
                  aria-disabled={disabled || undefined}
                  tabIndex={disabled ? -1 : undefined}
                  style={{
                    minWidth: "39px",
                    width: "39px",
                  }}
                >
                  <span
                    style={{
                      position: "relative",
                      // right: "2.5px",
                    }}
                  >
                    All
                  </span>
                </a>
              );
            return (
              <a
                key={index}
                className={`nav-item rlmargin-z nav-link custom-hover-tabs-z-index note-categories-spaces table-tab 
                    ${!disabled && selectedTab === tab.id ? "active" : ""}
                    `}
                onClick={disabled ? undefined : () => handleTabClick(tab.id)}
                aria-disabled={disabled || undefined}
                tabIndex={disabled ? -1 : undefined}
                id={cn}
                style={{
                  gap: "5px",
                  width: "max-content",
                }}
              >
                {tab.leftHand && tab.span}

                {tab.label !== "" && (
                  <span className="notes-table-component-tab-name display-none-of-labels">
                    {tab.label}
                  </span>
                )}
                {tab.rightHand && tab.span}
              </a>
            );
          })}
        </div>
      </div>
    </nav>
  );
};

export default TabsComponentNotesLevel;
